/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Draftemail_Scheduledlocknotice4Inputs */

const en_coinvestments_draftemail_scheduledlocknotice4 = /** @type {(inputs: Coinvestments_Draftemail_Scheduledlocknotice4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This email is scheduled, so may not be edited.`)
};

/**
* | output |
* | --- |
* | "This email is scheduled, so may not be edited." |
*
* @param {Coinvestments_Draftemail_Scheduledlocknotice4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_draftemail_scheduledlocknotice4 = /** @type {((inputs?: Coinvestments_Draftemail_Scheduledlocknotice4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Draftemail_Scheduledlocknotice4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_draftemail_scheduledlocknotice4(inputs)
});
export { coinvestments_draftemail_scheduledlocknotice4 as "coInvestments_draftEmail_scheduledLockNotice" }